// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import VerifyOtpActionType from './verify-otp.types';
import {
	verifyMemberNumberOtpSuccess,
	verifyMemberNumberOtpFailure,
	verifyMemberNumberOtpUserResponseChanged,
	reSendOtpSuccess,
	reSendOtpFailure,
	reSendOtpResponseChanged,
} from './verify-otp.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { addMemberMobileNumberVeriyOtp, verifyResendOtp } from './verify-otp.service';

/** ***************** Otp Verify Mobile Number Start ************************/
export function* verifyOtpMemberPhoneNumber({ payload }: any) {
	try {
		const key = 'AddMemberOtpVerify';
		const { verifyOtp, userID, memberID, companyID, databaseName, memberPhoneNumber } = payload;

		const jsonData = {
			VerifyOtp: verifyOtp,
			UserID: userID,
			MemberID: memberID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			Secratekey: key,
			MemberPhoneNumber: memberPhoneNumber,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addMemberMobileNumberVeriyOtp, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyMemberNumberOtpFailure(responseData.data));
		} else {
			yield put(verifyMemberNumberOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyMemberNumberOtpFailure(error));
	}
}

export function* verifyMemberOtpResponseClear() {
	yield put(verifyMemberNumberOtpUserResponseChanged());
}

export function* onVeriyMemberOptStart() {
	yield takeLatest(
		VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_START,
		verifyOtpMemberPhoneNumber,
	);
}

export function* onVeriyMemberOptResponseRest() {
	yield takeLatest(
		VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_RESPONSE_REST_START,
		verifyMemberOtpResponseClear,
	);
}
/** ***************** Otp Verify Mobile Number End ************************/

/** ***************** Resend Otp Verify Mobile Number Start ************************/
export function* verifyOtpReSendRequest({ payload }: any) {
	try {
		const key = 'ReSendOtp';
		const { phoneNumber, memberID, databaseName, companyID } = payload;

		const jsonData = {
			PhoneNumber: phoneNumber,
			MemberID: memberID,
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			Secratekey: key,
		};

		const resendOtpData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(verifyResendOtp, resendOtpData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(reSendOtpFailure(responseData.data));
		} else {
			yield put(reSendOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(reSendOtpFailure(error));
	}
}

export function* resetReSendOtpStates() {
	yield put(reSendOtpResponseChanged());
}

export function* onVerifyOtpReSendStart() {
	yield takeLatest(VerifyOtpActionType.RE_SEND_OTP_START, verifyOtpReSendRequest);
}

export function* onReSendOtpResponseRest() {
	yield takeLatest(
		VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_RESET_START,
		resetReSendOtpStates,
	);
}
/** ***************** Resend Otp Verify Mobile Number End ************************/

export function* verifyOtpSaga() {
	yield all([
		call(onVeriyMemberOptStart),
		call(onVeriyMemberOptResponseRest),
		call(onVerifyOtpReSendStart),
		call(onReSendOtpResponseRest),
	]);
}
